import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid none;
  border-radius: 5px;
  text-align: center;
  background-color: white;
  margin: 2% 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  @media (max-width: 375px) {
    flex-direction: column;
    width: 90%;
    text-alight: center;
    padding: 29px;
    position: relative;
    margin: 8% 1%;
}
`
export const StyledCardF = styled.div`
display: flex;
flex-direction: row;
width: 100%;
border: 1px solid none;
border-left: 6px solid hsl(180, 29%, 50%);;
border-radius: 5px;
text-align: center;
background-color: white;
margin: 2% 0;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`
export const CardsCompany = styled.div `
    display: flex;
    flex-direction: column;
    width: 30%;
    padding: 5px 0;
    
    @media (max-width: 375px) {
      border-bottom-style : solid;
      border-color: hsl(180, 14%, 20%);
      border-width: 1px;
      font-size: 13px;
      width: 100%;
  }
    
`

export const CardsVacancy = styled.div `
    display: flex;
    flex-direction: row;
    padding: 5% 2%;
    width: 40%;
    @media (max-width: 375px) {
      display: grid;
      grid-template-columns: repeat(3, 30%);
      grid-template-row: repeat(2, 50%);
      width: 100%;
      padding: 5% 0%;
    }
`
export const CardsProfile = styled.div`
  width: 15%;
`
export const CompanyBody = styled.div`
    display: flex;
    flex-direction: row;
   
`
export const Title = styled.h2`
color: hsl(180, 29%, 50%);
font-weight: 700;

`
export const SubTitle = styled.h3`
text-align: start;
color: black;
font-size: 19px;
font-weight: 700;
cursor: pointer;
&:hover {
  color:  hsl(180, 29%, 50%);
}
`
export const ItemPrimaryN = styled.span`
    margin: 3%;
    width: 15%;
    height: 10%;
    background-color: hsl(180, 29%, 50%);
    border-radius: 12px;
    padding: 3%;
    color: white;
    text-align: center;
    font-size: 11px;
`
export const ItemPrimaryB = styled.span`
    margin: 3%;
    border-radius: 12px;
    padding: 3%;
    width: 20%;
    height: 10%;
    background-color: hsl(180, 14%, 20%);
    color: white;
    text-align: center;
    font-size: 11px;
`
export const ItemSecondary = styled.span`
    margin: 2%;
    padding: 2%;
    color: hsl(180, 8%, 52%);
    @media (max-width: 375px) {
      padding: 2px;
    }
`
export const ItemThird = styled.span`
    margin: 2% 2% 2% 0;
    padding: 2%;
    width: 15%;
    height: 25%;
    border-radius: 5px;
    background-color: hsl(180, 52%, 96%);
    color: hsl(180, 29%, 50%);
    cursor: pointer;
  &:hover {
    background-color:  hsl(180, 29%, 50%);
    color: white;
  }
  @media (max-width: 375px) {
    padding: 15% 40%;
    margin: 15%;
    font-size: 13px;
    }

`
export const Img = styled.img `
  margin: 50px 10px;
  @media (max-width: 375px) {
  position: absolute;
  top: -60px;
  }
`